import { Flex } from "Element/Flex";
import styled from "styled-components";

export const MintContentWrapper = styled(Flex)`
  margin-bottom: 80px;
`;

export const StyledTitle = styled.h1`
  text-align: center;
  line-height: 88%;
  ${({ theme }) => theme.fontStyle.hero1}
  margin: 0 0 80px;
`;
